import { useQuery } from "@tanstack/react-query";
import { Navigate, useLocation } from "react-router-dom";

import { api } from "../api/client";
import { Card, EmptyState, Skeleton } from "../components/ui";

/**
 * "My profile" resolves the signed-in login to its own employment record and
 * hands off to the employee profile. An employee only ever reaches their own
 * record: the API scopes a non-manager to self, so there is no id to tamper
 * with here.
 */
export function MyProfilePage() {
  const location = useLocation();
  const me = useQuery({
    queryKey: ["employee-me"],
    queryFn: ({ signal }) => api.employeeMe(signal),
  });

  if (me.isPending) {
    return (
      <Card>
        <Skeleton className="h-6 w-48" />
      </Card>
    );
  }
  if (me.isError) {
    return (
      <EmptyState
        title="No employee record linked to this login"
        body="Ask an owner to link your login to your employee record under Employees."
      />
    );
  }
  return <Navigate to={`/people/employees/${me.data.id}${location.search}`} replace />;
}
